import { Address } from '../types/address';

export function getFullLineAddress(address: Address) {
  return `${address.address1}${address.address2 ? `, ${address.address2}` : ''}, ${address.city}, ${address.state} ${address.zipcode}`;
}
